<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <CustomerProposalStatusModal
          ref="modalComponent"
          @updateList="callData"
        ></CustomerProposalStatusModal>
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Propostas</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <fieldset
                    class="btn-group btn-group-sm"
                    aria-label="Menu das propostas"
                  >
                    <legend></legend>
                    <span
                      class="btn btn-outline-brand"
                      @click="openSaveProposals('add')"
                      v-b-tooltip.hover
                      title="Nova Proposta!"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Cadastrar
                    </span>
                  </fieldset>
                </div>
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount === 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 100 }">
                      <a @click="amount = 100" class="page-link paginate"
                        >100</a
                      >
                    </li>
                    <li class="page-item" :class="{ selected: amount === 150 }">
                      <a @click="amount = 150" class="page-link paginate"
                        >150</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else
                  >Nenhum item a ser exibido.</span
                >
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table
                  class="table table-striped- table-bordered table-hover table-checkable"
                >
                  <caption></caption>
                  <thead>
                    <tr>
                      <th
                        style="width: 60px; white-space: nowrap"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType === 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Proposta
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType === 'id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType === 'id' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType !== 'id'"
                        ></span>
                      </th>
                      <th
                        class="text-center align-middle"
                        style="width: 200px; white-space: nowrap"
                      >
                        Razão Social/Nome cliente
                      </th>
                      <th
                        class="text-center align-middle"
                        style="width: 150px; white-space: nowrap"
                      >
                        Vendedor
                      </th>
                      <th
                        class="text-center align-middle"
                        style="width: 150px; white-space: nowrap"
                      >
                        Data proposta
                      </th>
                      <th
                        class="text-center align-middle"
                        style="width: 150px; white-space: nowrap"
                      >
                        Status
                      </th>
                      <th
                        class="text-center align-middle"
                        style="width: 80px; white-space: nowrap"
                      >
                        Ações
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.businessExecutive"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @blur="callData"
                          v-mask="'##/##/####'"
                          v-model="filters.proposalDate"
                        />
                      </td>
                      <td>
                        <SelectProposalStatuses
                          class="form-control-sm"
                          :first="'Todos'"
                          :selected="filters.status"
                          @change="changeFilterStatus($event)"
                        />
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm"
                          @click="clearFilters"
                          v-b-tooltip.hover
                          title="Clique para limpar os filtros"
                        >
                          <i class="far fa-eraser"></i> Limpar
                        </button>
                      </td>
                    </tr>
                    <tr v-for="(proposal, id) in data.data" :key="id">
                      <td class="text-center align-middle">
                        {{ proposal.id }}
                      </td>
                      <td class="text-left align-middle">
                        {{ proposal.name }}
                      </td>
                      <td class="text-center align-middle">
                        {{ proposal.business_executive.name }}
                      </td>
                      <td class="text-center align-middle">
                        {{ proposal.proposal_date | date }}
                      </td>
                      <td class="text-center align-middle">
                        {{ proposal.status.status }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        <a
                          href="#"
                          @click.prevent.stop="
                            openSaveProposals(proposal.id, 'put')
                          "
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Editar Cadastro"
                        >
                          <i class="fas fa-edit"></i>
                        </a>
                        <a
                          href
                          @click.prevent.stop="confirmDel(proposal.id)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Delete"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </a>
                        <a
                          href
                          @click.prevent.stop="openModal(proposal)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Atualizar status"
                        >
                          <i class="fas fa-sync-alt"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else
                  >Nenhum item a ser exibido.</span
                >
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                    >
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 2"
                      >
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                      >
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">
                        {{ data.current_page }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page === data.last_page,
                      }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                      >
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page + 1 === data.last_page,
                      }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 2"
                      >
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page === data.last_page,
                      }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page === data.last_page,
                      }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <ProposalsModal v-if="showProposalSave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showProposalSave"
          @click="closeSaveCustomer()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import ProposalsModal from '@/components/customers/proposals/CustomerProposalModal';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin.js';
import CustomerProposalStatusModal from '@/components/customers/proposals/CustomerProposalStatusModal';
import SelectProposalStatuses from '@/components/forms/SelectProposalStatuses';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin, validationFilterValueMixin],
  name: 'CustomerProposals',
  components: {
    ProposalsModal,
    CustomerProposalStatusModal,
    SelectProposalStatuses,
  },
  data() {
    return {
      data: {},
      sortType: localStorage.proposalsSortType
        ? localStorage.proposalsSortType
        : 'id',
      sortReverse: localStorage.proposalsReverse
        ? localStorage.proposalsReverse
        : false,
      amount: localStorage.proposalsDataAmount
        ? localStorage.proposalsDataAmount
        : 100,
      page: localStorage.proposalsDataPage ? localStorage.proposalsDataPage : 1,
      filters: {
        id: localStorage.proposalsFilterId
          ? localStorage.proposalsFilterId
          : '',
        name: localStorage.proposalsFilterName
          ? localStorage.proposalsFilterName
          : '',
        businessExecutive: localStorage.proposalsFilteBusinessExecutive
          ? localStorage.proposalsFilterBusinessExecutive
          : '',
        proposalDate: localStorage.proposalsFilterProposalDate
          ? localStorage.proposalsFilterProposalDate
          : '',
        status: localStorage.proposalsFilterStatus
          ? localStorage.proposalsFilterStatus
          : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showProposalSave() {
      return this.$store.state.showProposalSave;
    },
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.businessExecutive = '';
      this.filters.proposalDate = '';
      this.filters.status = '';
      this.filters.sortType = 'description';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('proposalsFilterId', this.filters.id);
      localStorage.setItem('proposalsFilterName', this.filters.name);
      localStorage.setItem(
        'proposalsFilteBusinessExecutive',
        this.filters.businessExecutive
      );
      localStorage.setItem(
        'proposalsFilterProposalDate',
        this.filters.proposalDate
      );
      localStorage.setItem('proposalsFilterStatus', this.filters.status);
      localStorage.setItem('proposalsDataAmount', this.amount);
      localStorage.setItem('proposalsDataPage', this.page);
      localStorage.setItem('proposalsSortType', this.sortType);
      localStorage.setItem('proposalsSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&businessExecutive=${
        this.filters.businessExecutive ? this.filters.businessExecutive : ''
      }
      &proposalDate=${
        this.filters.proposalDate ? this.filters.proposalDate : ''
      }
      &status=${this.filters.status ? this.filters.status : ''}&amount=${
        this.amount
      }&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/proposal/search/${this.convertFilters()}`;
      console.log(url);
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    openSaveProposals(id, type) {
      this.$store.state.showProposalSave = id;
      if (id !== 'add') {
        this.$store.state.showActionProposalSave = type ? type : null;
      }
    },
    closeSaveCustomer() {
      this.$store.state.showProposalSave = null;
      this.callData();
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm(
          'Tem certeza que deseja excluir a proposta selecionada?',
          {
            size: 'md',
            contentClass: 'p-3',
            bodyClass: 'modal-body-fix',
            buttonSize: 'md',
            okVariant: 'danger',
            okTitle: 'Confirmar exclusão',
            cancelTitle: 'Cancelar',
            cancelVariant: 'metal',
            footerClass: 'p-4',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.del(id);
          }
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/proposal/delete/${id}`;
      axios
        .get(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    openModal(proposalId, status) {
      this.$refs.modalComponent.setContent(proposalId, status);
      this.$refs.modalComponent.openModal();
    },
    changeFilterStatus(event) {
      this.filters.status = event;
      this.callData();
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
